import { useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';

export const useMobile = (breakpoint: number = 768) => {
  const [isMobile, setIsMobile] = useState(
    document.documentElement.clientWidth <= breakpoint,
  );

  const queryClient = useQueryClient();

  useEffect(() => {
    const handler = () => {
      const newIsMobile = document.documentElement.clientWidth <= breakpoint;
      if (isMobile !== newIsMobile) {
        queryClient.invalidateQueries();
      }
      setIsMobile(newIsMobile);
    };

    window.addEventListener('resize', handler);

    handler();

    return () => {
      window.removeEventListener('resize', handler);
    };
  }, [breakpoint, isMobile, queryClient]);

  return isMobile;
};
